import Head from 'next/head'
import { useRouter } from 'next/router'
import { ReactNode } from 'react'

import { useAuthStore } from '@/feature/auth'

import { LayoutContextProvider, Sidebar, TopbarMenu } from '@/lib/core/components/Layout'
import {
  LoadingWrapper,
  Main,
  PageWrapper,
  TopBar,
} from '@/lib/core/components/Layout/Layout.styles'
import { Loader } from '@/lib/core/components/Loader'
import { LogoSmall } from '@/lib/core/components/Logo'
import { unRestrictedRoutes } from '@/lib/core/constants/routes'
import { useSidebarStore } from '@/lib/stores/sidebarStore'

type LayoutProps = {
  children: ReactNode
}

export const Layout = ({ children }: LayoutProps) => {
  const { route } = useRouter()
  const authStore = useAuthStore()
  const isMenuExpanded = useSidebarStore((state) => state.isExpanded)

  if (authStore.isInitializing) {
    return (
      <LoadingWrapper>
        <Loader />
      </LoadingWrapper>
    )
  }

  if (!authStore.isAuthenticated || unRestrictedRoutes.includes(route)) {
    return children
  }

  return (
    <LayoutContextProvider value={{ isMenuExpanded }}>
      <PageWrapper $isMenuExpanded={isMenuExpanded}>
        <Head>
          <title>Bridge - GoMetro</title>
        </Head>
        <TopBar>
          <LogoSmall />
          <TopbarMenu />
        </TopBar>
        <Sidebar />
        <Main>{children}</Main>
      </PageWrapper>
    </LayoutContextProvider>
  )
}
